export const WC_GROUP_CREATED_COPY = {
  BADGE: 'Squad created',
  IS_LIVE: 'is live.',
  SUBTITLE: 'Send the code below and they\'re in.',
  INVITE_CODE_LABEL: 'Invite code',
  COPY_CODE_A11Y: 'Copy invitation code',
  CODE_COPIED: 'Code copied!',
  COPY_CODE: 'Copy code',
  SHARE_LINK: 'Share link',
  LINK_COPIED: 'Link copied!',
  VIEW_SQUAD: 'Go to squad dashboard',
  BACK_TO_GROUPS: 'Back to all groups',
} as const;
